import React, { useEffect, useState } from "react";
import { BadgeIndianRupee, FileCheck2, FileText, Image, Images, MessageSquare, Newspaper, RefreshCw, School, Video } from "lucide-react";
import { api } from "../../lib/api";

const cards = [
  { key: "banners", label: "Banners", icon: Image },
  { key: "galleries", label: "Gallery Images", icon: Images },
  { key: "videos", label: "Videos", icon: Video },
  { key: "feeStructures", label: "Fee Structures", icon: BadgeIndianRupee },
  { key: "disclosures", label: "Disclosure Documents", icon: FileText },
  { key: "cbseDetails", label: "CBSE Details", icon: School },
  { key: "transferCertificates", label: "Transfer Certificates", icon: FileCheck2 },
  { key: "enquiries", label: "Total Enquiries", icon: MessageSquare },
  { key: "newEnquiries", label: "New Enquiries", icon: MessageSquare },
  { key: "news", label: "News Items", icon: Newspaper },
];

export default function Dashboard() {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    api.stats().then((res) => setStats(res.data)).catch((err) => setError(err.message)).finally(() => setLoading(false));
  }, []);

  return <section className="admin-page"><div className="admin-page-head"><div><h2>Dashboard</h2><p>Website content overview and enquiry status.</p></div></div>{error && <div className="admin-alert error">{error}</div>}{loading ? <div className="admin-card admin-empty"><RefreshCw className="spin" /> Loading dashboard...</div> : <div className="admin-stat-grid">{cards.map(({ key, label, icon: Icon }) => <article className="admin-stat-card" key={key}><span><Icon size={22} /></span><div><strong>{stats[key] ?? 0}</strong><p>{label}</p></div></article>)}</div>}</section>;
}
